export const setupKeys = {
  credentials: (locationId: string) => ['insurance', 'setup', 'credentials', locationId] as const,
  providers: (locationId: string) => ['insurance', 'setup', 'providers', locationId] as const,
  readiness: (locationId: string) => ['insurance', 'setup', 'readiness', locationId] as const,
};

export const payerKeys = {
  directory: (q: string) => ['insurance', 'payers', 'directory', q] as const,
  // Prefix of directory(q) for all q — invalidates every directory search result at once.
  directoryPrefix: () => ['insurance', 'payers', 'directory'] as const,
  directoryEntry: (payerId: string) => ['insurance', 'payers', 'directoryEntry', payerId] as const,
  directoryAll: () => ['insurance', 'payers', 'directoryAll'] as const,
  list: (locationId: string) => ['insurance', 'payers', 'list', locationId] as const,
  // Prefix of list(locationId) for all locationId — invalidates every location's payer list.
  listPrefix: () => ['insurance', 'payers', 'list'] as const,
  map: (payerId: string) => ['insurance', 'payers', 'map', payerId] as const,
  deleteImpact: (payerId: string) => ['insurance', 'payers', 'deleteImpact', payerId] as const,
  agencyLocations: () => ['insurance', 'payers', 'agencyLocations'] as const,
  versionDetail: (versionId: string) =>
    ['insurance', 'payers', 'versionDetail', versionId] as const,
  chartingRun: (runId: string) => ['insurance', 'payers', 'chartingRun', runId] as const,
  chartingRuns: (payerId: string) => ['insurance', 'payers', 'chartingRuns', payerId] as const,
};
